moment = require('moment')
_ = require('lodash')
{dispatchResizeEvent} = require('../../../../../utils')

module.exports = (
  $rootScope,
  $scope,
  $stateParams,
  $uibModal,
  $filter,
  $http,
  endpoints,
  settings,
  $state,
  $timeout,
  SearchWorker,
  SearchResults,
  User
  ) ->

  $scope.user = User
  $scope.offset = offset = $stateParams.offset

  alreadySwitchedToResultsTab = false

  $scope.newsFaviconURL = settings.NEWS_FAVICON_URL

  # We start by having the source info active, but as soon as the worker
  # finishes we make the results tab active.
  # The way angular-bootstrap-ui implements this is quite stupid. See
  # https://github.com/angular-ui/ui-codemirror/issues/42
  $scope.activeWorkerTab = "source"

  $scope.getResultFromFingerprint = (fingerprint) ->
    return (result for result in $scope.results when result.fingerprint is fingerprint)[0]

  $scope.$watchCollection 'selectedDocs', (value) ->
    if $scope.topics
      for risk, topics of $scope.topics
        for topic, results of topics
          for result in results
            result.isSelected = $scope.getIsDocSelected(result)


  $scope.toggleDocsInTopic = (results) ->
    # If all docs in topic are selected, de-select all of them
    # otherwise select all of them
    toggleValue = !$scope.allDocsInTopicSelected(results)()
    for result in results when !$scope.starredDocs[result.id]
      $scope.setIsDocSelected(result, toggleValue)

  $scope.allDocsInTopicSelected = (results) ->
    ->
      (result for result in results when !result.isSelected and !$scope.starredDocs[result.id]).length == 0

  $scope.checkboxToggleStatus = (results) ->
    ->
      (result for result in results when result.isSelected).length > 0

  $scope.getDomainFromURL = (url) ->
    (new URL(url)).hostname.replace("www.", "")

  # =========================
  # --------- Scope ---------
  # =========================

  $scope.dateFilter = {}
  $scope.maxDate = new Date()

  $scope.filterByDate = ->
    $scope.setDateRefinementMade(true)
    $scope.setDateRange($scope.dateFilter.from_date, $scope.dateFilter.to_date)
    $scope.refineSearch()

  $scope.showDateFilter = ->
    (
      $scope.results?.$resolved and
      ($scope.worker.hasResults() or $scope.worker.hasDateFilter()) and
      ($scope.timelineSet and $scope.timeline.length)
    ) or $scope.worker?.alwaysShowDateFilter()

  $scope.hasFactivaTimeline = (facets) ->
    return facets.factivaTimeline != null and facets.factivaTimeline != undefined and facets.factivaTimeline.length > 0

  $scope.factivaDateRangeProblem = (facets, from_date, to_date) ->
    to_date = moment(to_date, 'YYYY-MM-DD').unix()
    from_date = moment(from_date, 'YYYY-MM-DD').unix()
    date_diff = $scope.getDateYearsDiff(to_date, from_date)
    return facets['factivaTimeline']? and date_diff > 10

  $scope.getDateYearsDiff = (to_unix, from_unix) ->
    return (to_unix - from_unix) / 60 / 60 / 24 / 365.25

  $scope.timelinePointScalar = (facets) ->
    SCALE_FACTOR =
      year: 1
      quarter: 4
      month: 12
      week: 52
      day: 365
    if SCALE_FACTOR[facets.interval] == undefined or SCALE_FACTOR[facets.factivaInterval] == undefined
      return 1
    return SCALE_FACTOR[facets.factivaInterval] / SCALE_FACTOR[facets.interval]

  makeESTimeLineOnly = (facets) ->
    timeline = []
    if (facets.timeline != null and facets.timeline != undefined and facets.timeline.length > 0)
      to_date = moment().unix()
      for point in facets.timeline
        timelinepoint = [new Date(point.time), point.count]
        timeline.push(timelinepoint) unless $scope.getDateYearsDiff(to_date, point.time / 1000) > 10
    return timeline

  makeJointTimeLine = (facets, from_date, to_date) ->
    newESPoint = (time, count) ->
      return [new Date(time), count, null]
    newFactivaPoint = (time, count) ->
      return [new Date(time), null, count]
    checkIntitialPoint = (timelineData, newPoint, min_date) ->
      if min_date? and timelineData[0].time > min_date
        timeline.push(newPoint(min_date, 0))
        timeline.push(newPoint(timelineData[0].time, 0))
    checkLastPoint = (timelineData, newPoint, max_date) ->
      if max_date? and timelineData[timelineData.length - 1].time < max_date
        timeline.push(newPoint(timelineData[timelineData.length - 1].time, 0))
        timeline.push(newPoint(max_date, 0))
    oldestDate = (facets, from_date) ->
      dates = []
      if from_date > -1
        dates.push(from_date)
      if (facets.timeline != null and facets.timeline != undefined and facets.timeline.length > 0)
        dates.push(facets.timeline[0].time)
      if (facets.factivaTimeline != null and facets.factivaTimeline != undefined and facets.factivaTimeline.length > 0)
        dates.push(facets.factivaTimeline[0].time)
      dates.sort (a, b) ->
        a - b
      return dates[0]
    newestDate = (facets, to_date) ->
      dates = []
      if to_date > -1
        dates.push(to_date)
      if (facets.timeline != null and facets.timeline != undefined and facets.timeline.length > 0)
        dates.push(facets.timeline[facets.timeline.length - 1].time)
      if (facets.factivaTimeline != null and facets.factivaTimeline != undefined and facets.factivaTimeline.length > 0)
        dates.push(facets.factivaTimeline[facets.factivaTimeline.length - 1].time)
      dates.sort (a, b) ->
        b - a
      return dates[0]
    timeline = []
    oldestPoint = oldestDate(facets, from_date)
    newestPoint = newestDate(facets, to_date)
    if (facets.timeline != null and facets.timeline != undefined and facets.timeline.length > 0)
      checkIntitialPoint(facets.timeline, newESPoint, oldestPoint)
      for point in facets.timeline
        timelinepoint = newESPoint(point.time, point.count)
        timeline.push(timelinepoint)
      checkLastPoint(facets.timeline, newESPoint, newestPoint)
    if (facets.factivaTimeline != null and facets.factivaTimeline != undefined and facets.factivaTimeline.length > 0)
      scale = $scope.timelinePointScalar(facets)
      checkIntitialPoint(facets.factivaTimeline, newFactivaPoint, oldestPoint)
      for point in facets.factivaTimeline
        timeline.push(newFactivaPoint(point.time, point.count * scale))
      checkLastPoint(facets.factivaTimeline, newFactivaPoint, newestPoint)
    return timeline


  $scope.makeTimeline = (facets, from_date, to_date, merge_factiva = true) ->
    if merge_factiva
      return makeJointTimeLine(facets, from_date, to_date)
    else
      return makeESTimeLineOnly(facets)

  $scope.minMaxDatesOfTimeline = (facets) ->
    arrays = []
    addArray = (array) ->
      if array != null and array != undefined and array.length > 0
        arrays.push(array)
    addArray(facets.timeline)
    addArray(facets.factivaTimeline)

    mins = []
    maxes = []
    for array in arrays
      mins.push array[0].time
      maxes.push array[array.length - 1].time

    min_date = Math.min.apply(null, mins)
    max_date = Math.max.apply(null, maxes)

    return [min_date, max_date]

  $scope.markDuplicates = ( worker ) ->

    # Note that a Result will already have a 'duplicated' field set by the server-side.
    # It can be null, in which case we did no deduplication server-side, or it can be
    # a true/false value, if we did. They will never be mixed, but the cleanest way
    # to support this is just to not do UI level deduplication if the first result
    # is serverside deduplicated.

    wasServersideDeduplicated = (result) -> (
      result.duplicated != null
    )

    if worker.isNewsSearch() or worker.isPythia()

      headlines = []
      snippets = []

      for result in $scope.results

        if wasServersideDeduplicated(result)
          break

        # mark results with a headline we've seen before
        if result.title in headlines
          result.duplicated = true
        else
          headlines.push(result.title)

        # mark results with a snippet we've seen before
        if result.snippet in snippets
          result.duplicated = true
        else
          snippets.push(result.snippet)

      return worker

  $scope.sendChromeMessage = ( extensionId, message, callback ) ->
    if extensionId
      chrome.runtime.sendMessage(extensionId, message, callback)

  prepareQueryPart = (query) ->
    # Google search syntax is a bit hard to understand, but when we specify
    # a site within parentheses and a trailing slash (e.g. "(site:sc.com/)")
    # we often don't get any results. We also have problems if we wrap everything
    # in double quotes. Hence we treat this query part separately.
    if query.indexOf("site:") == 0
      return if query[query.length - 1] == '/' then query.slice(0, -1) else query
    "\"#{query}\""

  $scope.assembleQuery = () ->
    activeTabIndex = $scope.getActiveTabIndex()

    # If merged names are not supported, don't do them
    if $scope.iteration.merged_name_variations?.length
      names = (prepareQueryPart(i.name) for i in $scope.iteration.merged_name_variations)
      query = names.join(" OR ")
    else
      query = prepareQueryPart($scope.worker.query)
    return "(" + query + ")"

  $scope.startHarmoniaTask = () ->
    query = $scope.assembleQuery()
    harmonia_config = $scope.worker.engine.harmonia_config

    if !harmonia_config
      $rootScope.message = "It appears this source has not been configured properly. Please contact your account manager for assistance."
      return

    $scope.sendChromeMessage(
      $scope.installedUDAID(),
      {
        type: 'D3request',
        query: query,
        source_url: $filter('populateTemplateURL')($scope.worker.engine.url, {query: query}),
        hostname: window.location.origin,
        search_results_url: window.location.origin + endpoints.SearchResult,
        search_workers_url: window.location.origin + endpoints.SearchWorker,
        csrf_url: window.location.origin + endpoints.CSRF,
        project_starred_docs_url: window.location.origin + endpoints.ProjectStarredDocument
        worker_id: $scope.worker.id
        project_id: $scope.project.id
        workflow_step: $scope.step.id
        tagging_config: $scope.user.client_tagging_configs[0] || null
        blacklist: $scope.user.harmonia_blacklist || []
        source_config: {
          name: if harmonia_config then harmonia_config.name else "No name",
          instructions: if harmonia_config then harmonia_config.instructions else "No instructions"
          get_search_results_xpath: if harmonia_config then harmonia_config.get_search_results else "No xpath",
          get_search_result_title_xpath: if harmonia_config then harmonia_config.get_search_result_title else "No xpath",
          get_search_result_url_xpath: if harmonia_config then harmonia_config.get_search_result_url else "No xpath",
          get_search_result_snippet_xpath: if harmonia_config then harmonia_config.get_search_result_snippet else "No xpath",
          get_tagging_toolbar_location_xpath: if harmonia_config then harmonia_config.get_tagging_toolbar_location else null,
          wait_for_element_to_appear_xpath: if harmonia_config then harmonia_config.wait_for_element_to_appear else null,
          wait_for_element_to_disappear_xpath: if harmonia_config then harmonia_config.wait_for_element_to_disappear else null,
        }
        user: $scope.user
      },
      ( response ) ->
        if !(response && response.success)
          $rootScope.message = "Unable to communicate with the Harmonia extension. ' +
          'Please verify that it is installed and check your internet connection."
    )

  $scope.goToSource = () ->
    if ($scope.installedUDAID())
      $scope.startHarmoniaTask()
      $scope.notifyHarmoniaOpened()
      $scope.pollForNewUDAResults()
    else
      $rootScope.message = 'To make use of this feature, please install the Arachnys Harmonia extension'
    return true

  $scope.notifyHarmoniaOpened = () ->
    # send API request to change results_available to 0 if null
    $scope.worker.updateResultsAvailable()

  $scope.pollForNewUDAResults = () ->
    $scope.loading = true
    $scope.results = $scope.worker.queryResults( $scope.getResultsPerPage(), offset )
    mergeKey = (worker) -> worker.id
    $scope.results.poll(
      { worker: $scope.worker.id, limit: $scope.getResultsPerPage(), offset: offset, prefetch_next_page: false },
      settings.UDA_POLLING_INTERVAL,
      mergeKey,
      () ->
        $scope.worker.updateResultsCount()
        $scope.loading = false
    )
    $scope.$on('$destroy', () ->
      $scope.results.stopPolling()
    )

  $scope.refreshSearchResults = () ->
    $scope.loading = true
    $scope.worker.updateResultsCount()
    $scope.results = $scope.worker.queryResults( $scope.getResultsPerPage(), offset )
    $scope.results.$promise.then () ->
      $scope.loading = false

  $scope.get_source_url = () -> $filter('populateTemplateURL')($scope.worker.engine.url, {query: $scope.assembleQuery()})

  $scope.processWorker = ( worker ) ->
    if not worker
      return

    $scope.setWorker(worker)
    # set the current page based on the type worker
    $scope.resultsPagination = {page: offset / $scope.getResultsPerPage() + 1}

    # Open UDA if that option was selected
    if $stateParams.goToSource == "true"
      $scope.goToSource()
      # hack to make sure that reloading the page doesn't re-open UDA
      $state.go('project.workflow.step.iteration.facets.worker', {workerId: worker.id, offset: 0, goToSource: false}, {notify: false})

    resultsQueried = () ->
      $scope.results

    processResults = () ->
      if $scope.results.length < $scope.getResultsPerPage() and offset + $scope.results.length < worker.getResultsCount()
        $scope.resultsError = "Sorry, we are able only to show the first
          #{worker.results_retrieved} results for this source.
          Please refine your search to find more."
      else
        $scope.resultsError = null

      $scope.markDuplicates(worker)

      # setup facets so we can display them
      if worker.facets?
        facets = worker.facets
        $scope.setFacets(worker)
        $scope.timelineSet = true
        $scope.factivaTimelineSet = $scope.hasFactivaTimeline(facets) and not $scope.factivaDateRangeProblem(facets, worker.from_date, worker.to_date)

        workerFromTimestamp = moment(worker.from_date, 'YYYY-MM-DD').unix() * 1000
        workerToTimestamp = moment(worker.to_date, 'YYYY-MM-DD').unix() * 1000

        $scope.timeline = $scope.makeTimeline(facets,
          workerFromTimestamp,
          workerToTimestamp,
          $scope.factivaTimelineSet)
        [timelineMinDate, timelineMaxDate] = $scope.minMaxDatesOfTimeline(facets)

        if worker.from_date  # example: 2024-01-01
          timelineMinDate = workerFromTimestamp
          $scope.dateFilter.from_date = worker.from_date
          $scope.setDateRange(timelineMinDate, timelineMaxDate)
        else if $scope.timeline.length and $scope.factivaTimelineSet
          $scope.setDateRange(timelineMinDate, timelineMaxDate)

        if worker.to_date  # example: 2024-01-01
          timelineMaxDate = workerToTimestamp
          $scope.dateFilter.to_date = worker.to_date
          $scope.setDateRange(timelineMinDate, timelineMaxDate)
        else if $scope.timeline.length and $scope.factivaTimelineSet
          $scope.setDateRange(timelineMinDate, timelineMaxDate)

        timelineStartDate = if $scope.factivaTimelineSet then $scope.timelineMinDate else moment().subtract(10, 'years').unix() * 1000
        timelineMinDate =  Math.max(timelineStartDate, timelineMinDate)
        $scope.timelineOptions.dateWindow = [timelineMinDate, timelineMaxDate]
        $scope.timelineOptions.userZoom = [timelineMinDate, timelineMaxDate]
        $scope.timelineOptions.labels = if $scope.factivaTimelineSet then ['Date', 'News', 'Factiva'] else ['Date', 'News']
        $scope.timelineOptions.changeUserZoom = (fromTimestamp, toTimestamp) ->
          $scope.onTimelineZoom(fromTimestamp, toTimestamp)

      if worker.factiva_start_date  # example: 2024-01-01
        $scope.dateFilter.from_date = worker.factiva_start_date

      if worker.factiva_end_date  # example: 2024-01-01
        $scope.dateFilter.to_date = worker.factiva_end_date

      $scope.timelineSet = $scope.timeline?


    if worker.hasFinished() and not resultsQueried()
      $scope.refreshSearchResults().then () ->
        processResults()

    # We only want to switch to the results tab once as the user may switch
    # to another tab thereafter.
    if worker.hasFinished() and not alreadySwitchedToResultsTab
      $scope.activeWorkerTab = "results"
      $scope.alreadySwitchedToResultsTab = true

  getWorker = () ->
    $scope.workers.getById( $stateParams.workerId )

  $scope.$watch(
    () -> if getWorker() then getWorker().state else undefined,
    () ->
      $scope.processWorker( getWorker() )
  )

  areDatesDifferent = () ->
    if !$scope.timelineOptions.userZoom?[0] || !$scope.timeline
      return false
    if !areDatepickerDatesValid()
      return true
    fromDate = moment($scope.dateFilter.from_date).format("YYYY-MM-DD")
    toDate = moment($scope.dateFilter.to_date).format("YYYY-MM-DD")
    zoomFromDate = moment($scope.timelineOptions.userZoom[0]).format("YYYY-MM-DD")
    zoomToDate = moment($scope.timelineOptions.userZoom[1]).format("YYYY-MM-DD")
    return fromDate != zoomFromDate || toDate != zoomToDate

  datepickerTimelineSync = () ->
    currentWorker = getWorker()
    pickerFrom = moment($scope.dateFilter.from_date).format("YYYY-MM-DD")
    pickerTo = moment($scope.dateFilter.to_date).format("YYYY-MM-DD")
    timelineFrom = moment($scope.timelineOptions.userZoom[0]).format("YYYY-MM-DD")
    timelineTo = moment($scope.timelineOptions.userZoom[1]).format("YYYY-MM-DD")
    currentFromDate = currentWorker.from_date
    currentToDate = currentWorker.to_date
    preventDoubleChange = false

    if !preventDoubleChange && ( pickerFrom != currentFromDate || pickerTo != currentToDate )
      preventDoubleChange = true
      currentWorker.from_date = pickerFrom
      currentWorker.to_date = pickerTo

      if currentWorker.facets?

        facets = currentWorker.facets
        $scope.setFacets(currentWorker)

        $scope.factivaTimelineSet =
          $scope.hasFactivaTimeline(facets) &&
          !$scope.factivaDateRangeProblem(facets, currentWorker.from_date, currentWorker.to_date)

        fromTimestamp = moment(currentWorker.from_date, 'YYYY-MM-DD').unix() * 1000
        toTimestamp = moment(currentWorker.to_date, 'YYYY-MM-DD').unix() * 1000

        $scope.timeline = $scope.makeTimeline(facets,
          fromTimestamp,
          toTimestamp,
          $scope.factivaTimelineSet)

        $scope.setDateRange(fromTimestamp, toTimestamp)

        $scope.timelineOptions.dateWindow = [fromTimestamp, toTimestamp]

    if !preventDoubleChange && ( timelineFrom != currentFromDate || timelineTo != currentToDate )
      preventDoubleChange = true
      currentWorker.from_date = timelineFrom
      currentWorker.to_date = timelineTo
      $scope.dateFilter.from_date = timelineFrom
      $scope.dateFilter.to_date = timelineTo

      $scope.setDateRange(
        moment(timelineFrom, 'YYYY-MM-DD').unix() * 1000,
        moment(timelineTo, 'YYYY-MM-DD').unix() * 1000
      )

  $scope.onTimelineZoom = _.debounce(
    (fromTimestamp, toTimestamp) ->
      $scope.timelineOptions.userZoom = [fromTimestamp, toTimestamp]
      if !areDatepickerDatesValid()
        # if date fields are invalid we fill it with valid but different values and then sync it with timeline values
        $scope.dateFilter.from_date = moment(fromTimestamp + 86400000).format('YYYY-MM-DD')
        $scope.dateFilter.to_date = moment(toTimestamp).format('YYYY-MM-DD')
        datepickerTimelineSync(fromTimestamp, toTimestamp)
      else if $scope.timelineSet && areDatesDifferent()
        datepickerTimelineSync(fromTimestamp, toTimestamp)
    500
  )

  areDatepickerDatesValid = () ->
    if ($scope.dateFilter.from_date && $scope.dateFilter.to_date)
      return moment($scope.dateFilter.from_date).isValid() && moment($scope.dateFilter.to_date).isValid()

  $scope.changeDate = () ->
    # dates changed so the "Refine" button should be displayed
    $scope.timelineOptions.setDateRefinementMade()

    fromTimestamp = null
    toTimestamp = null

    if $scope.dateFilter.from_date != undefined && moment($scope.dateFilter.from_date).isValid()
      fromTimestamp = moment($scope.dateFilter.from_date, 'YYYY-MM-DD').unix() * 1000

    if $scope.dateFilter.to_date != undefined && moment($scope.dateFilter.to_date).isValid()
      toTimestamp = moment($scope.dateFilter.to_date, 'YYYY-MM-DD').unix() * 1000

    $scope.setDateRange(fromTimestamp, toTimestamp)

    # update the Timeline chart if these dates are valid and different
    if areDatepickerDatesValid() && areDatesDifferent()
      datepickerTimelineSync($scope.dateFilter.from_date, $scope.dateFilter.to_date)

  $scope.setFacets = (worker) ->
    facets = worker.facets
    $scope.setSourcesFacets(facets.sources)
    $scope.setCountriesFacets(facets.countries)
    $scope.setAdverseFacets(facets.adverse)
    $scope.setAdditionalFiltersFacets(facets.additional_filters)

  $scope.showAllTechnologies = false
  $scope.isWorker = true

  # This function is added because `ng-if` will created a child scope,
  # so should call a function to set values in parent scope.
  $scope.setShowAllTechnologies = (showAllTechnologies) ->
    $scope.showAllTechnologies = showAllTechnologies

  $scope.goToPage = ( pageNo ) ->
    limit = $scope.getResultsPerPage()
    offset = ( pageNo - 1 ) * limit
    state = 'project.workflow.step.iteration.facets.worker'
    $state.go( state, { offset: offset } )

  $scope.goToResultTab = () ->
    # When collapsing the sidebar while on another tab dygraph would go wonky
    # so trigger a resize event here.
    dispatchResizeEvent

  $scope.getResultsPerPage = ->
    if $scope.user.results_per_page
      return $scope.user.results_per_page
    else
      if $scope.worker?.isElasticSearch() or $scope.worker?.isLexisNexis() or $scope.worker?.isFactiva() or $scope.worker?.isPythia()
        return settings.SEARCH_RESULTS_PER_PAGE_LARGE
      else if $scope.worker?.isAccuity()
        return settings.SEARCH_RESULTS_PER_PAGE_MEDIUM
      else
        return settings.SEARCH_RESULTS_PER_PAGE

  $scope.allDocsOnPageSelected = () ->
    $scope.allDocsSelected($scope.results)

  $scope.toggleSelectedDocsOnPage = () ->
    $scope.toggleSelectedDocs($scope.results)

  $scope.saveSelectedDocsOnPageTags = (tagIdsToSave, annotation) ->
    $scope.saveSelectedDocsTags($scope.results, tagIdsToSave, annotation)

